import styled, { css } from 'styled-components';
import { motion } from 'motion/react';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${props => props.theme.sz.s40};
  position: relative;
`;

export const Blob = styled(motion.div)(
  ({ theme }) => css`
    align-items: center;
    background: ${theme.co.success40};
    border-radius: 56% 44% 54% 46% / 54% 57% 43% 46%;
    display: flex;
    height: ${theme.sz.s40};
    justify-content: center;
    position: absolute;
    transform: rotate(-10deg);
    width: ${theme.sz.s40};
  `,
);

Blob.defaultProps = {
  initial: {
    opacity: 1.0,
    scale: 0.2,
  },
  animate: {
    opacity: 1.0,
    scale: 1.0,
  },
  exit: {
    opacity: 0,
  },
};

export const Span = styled.span(
  ({ theme }) => css`
    color: ${theme.co.primary99};
    font-family: ${theme.DEPRECATED_ty.boing};
    font-size: ${theme.DEPRECATED_ty.display};
  `,
);
